export default "__VITE_ASSET__HEaAGWKn__"